module.exports = __webpack_public_path__ + "img/Moodja.fe96e59c.svg";